import React from 'react';
import Title from '../title';
import { Grid, Image } from 'semantic-ui-react';
import Sales from './sales';
import Purchase from './purchase';
import ReadCookie from '../../functions/readcookies';
import Server from '../../functions/server'
import $ from "jquery";
import OrderStatus from './orderstatus';
import './dashboard.css';
import Otheruser from './otheruser';
import Purchaserequest from './purchaserequest';
import Stocks from './stocks';
import Statements from '../Sales/CustomerStatement';
import Ticket from './ticket';
import Tickets from '../tickets';
import Loading from '../loading';
import VaigaiIcon from '../media/icon.png'

class Dashboard extends React.Component {

  state = {
    data: [],
    open: true,
    goLink: '',
    image: VaigaiIcon
  }

  componentDidMount() {
    this.getuser();
    this.menuControl();
  }

  menuControl() {
    let menuControl = this.props.menus;
    menuControl.map((z) => {
      if (z.type == 'menucontrol') {
        if (z.menu == 'dashboard') {
          this.setState({ allow: '1' })
        }
      }
    })
  }

  getuser() {
    let cook = (ReadCookie("vaigai"));
    let userId = cook.id;
    if (userId == 13 || userId == 1 || userId == 6) {
      this.getdetails();
    }
    else {
      this.setState({ open: false })
    }
  }

  getToday() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    if(dd < 10){
      dd = '0' + dd;
    }
    if(mm < 10){
        mm = '0' + mm;
    }
    today = yyyy+'-'+mm+'-'+dd;
    return today;
  }

  fromMonth() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    if(dd < 10){
      dd = '0' + dd;
    }
    if(mm < 10){
      mm = '0' + mm;
    }
    let fromMonth = yyyy+'-'+mm+'-01';
    return fromMonth;
  }

  fromYear() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    if(dd < 10){
      dd = '0 '+ dd;
    }
    if (mm < 3) {
      yyyy = yyyy - 1;
    }
    if(mm < 10){
      mm = '0'+ mm;
    }
    yyyy = yyyy - 1;
    let fromYear = yyyy+'-04-01';
    return fromYear;
  }

  getdetails() {
    let context = this;
    let branch = 0;
    let today = this.getToday();
    let fromMonth = this.fromMonth();
    let fromYear = this.fromYear();
    context.setState({ load: true, message: 'Getting Values' })
    $.ajax({
      type: 'POST',
      data: { 'branch': branch, 'today': today, 'fromMonth': fromMonth, 'fromYear': fromYear },
      url: Server() + 'dashboard/getdetails.php',
      success: function(data) {
        try {
          data = JSON.parse(data);
          context.setState({ data: data, load: false })
        } catch (e) {
          context.setState({ load: false })
        }
      },
      error: function(e) {
        alert('Try again!!')
        context.setState({ load: false });
      }
    });
  }

  render() {
    return (
      <div>
        <Title title={'Vaigai'} openDrawer={this.props.openDrawer}/>
        <Loading load={this.state.load} message={this.state.message} />
        { this.state.open ?
          (
            <div style={{padding: '2%'}}>
              <Grid>
                <Grid.Column mobile={16} tablet={16} computer={16}>
                  <Sales data={this.state.data} />
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={8}>
                  <Purchase data={this.state.data} />
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={4}>
                  <Ticket data={this.state.data} />
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={4}>
                  <Stocks data={this.state.data} />
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={16}>
                  <OrderStatus data={this.state.data} />
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={12}>
                  <Purchaserequest data={this.state.data} />
                </Grid.Column>
              </Grid>
            </div>
          ):
          (
            <div><Otheruser /></div>
          )
        }
      </div>
    );
  }
}

export default Dashboard;
